import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  style: {"width":"33rem","max-width":"80vw","max-height":"22rem"},
  class: "relative edit-body overflow-y-auto"
}
const _hoisted_2 = { class: "gap-x-3 px-6 flex justify-center flex-col" }
const _hoisted_3 = { class: "px-4 py-3 mb-6 bg-blue-lp-600 rounded-lg flex-col justify-center items-start gap-2.5 inline-flex" }
const _hoisted_4 = { class: "justify-start items-center gap-3 inline-flex" }
const _hoisted_5 = { class: "grow shrink basis-0" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "text-blue-lp-500 text-xs font-normal font-['Montserrat']" }, " Estimasi keberangkatan : ", -1)
const _hoisted_7 = { class: "text-blue-lp-500 text-xs font-bold font-['Montserrat']" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "my-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "dialog-airport",
    modelValue: _ctx.showModalComplete,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModalComplete = $event)),
    title: "Lengkapi data booking",
    persistent: "",
    customBody: "py-3",
    onReset: _ctx.onReset,
    showOverflow: ""
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_Icons, {
                name: "info",
                class: "w-5 text-blue-lp-500"
              }),
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode("span", _hoisted_7, _toDisplayString(_ctx.displayNextCotHour), 1)
              ])
            ])
          ]),
          _createVNode(_component_DataWrapper, {
            class: "my-2",
            label: "Komoditas Group (Kargo)",
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CustomDropdown, {
                class: "w-full",
                placeholder: "Pilih komoditas",
                options: _ctx.commodityOptions,
                onSelect: _ctx.onSelectCommodity,
                selectedItem: _ctx.commodityItem,
                isCustomWidth: "",
                isDisabled: _ctx.disableCommodityGroup
              }, null, 8, ["options", "onSelect", "selectedItem", "isDisabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: "NOG",
            optional: "",
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                onChange: _ctx.onChangeNog,
                modelValue: _ctx.formBooking.nog,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formBooking.nog = $event)),
                placeholder: "Masukan NOG"
              }, null, 8, ["onChange", "modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: "SHC",
            optional: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                disabled: "",
                modelValue: _ctx.shcValue,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.shcValue = $event)),
                placeholder: "Masukan SHC"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _hoisted_8,
          _createVNode(_component_lp_button, {
            textColor: "white",
            title: "Lanjutkan Booking Cargo",
            fontWeight: "semibold",
            color: "red-lp-100",
            isWidthFull: "",
            customClass: "py-2 px-8",
            onClick: _ctx.showModalConfirmationBookCargo
          }, null, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onReset"]))
}